function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
}

export function getLocalStorage(key: string): any {
  if (!isBrowser()) return null;

  const item = localStorage.getItem(key);
  if (!item) return null;

  try {
    return JSON.parse(item);
  } catch {
    return item;
  }
}

export function setLocalStorage(key: string, value: any): void {
  if (!isBrowser()) return;
  localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
}

export function removeLocalStorage(key: string): void {
  if (!isBrowser()) return;
  localStorage.removeItem(key);
}

export function getSessionStorage(key: string): any {
  if (!isBrowser()) return null;

  const item = sessionStorage.getItem(key);
  if (!item) return null;

  try {
    return JSON.parse(item);
  } catch {
    return item;
  }
}

export function setSessionStorage(key: string, value: any): void {
  if (!isBrowser()) return;
  sessionStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
}

export function removeSessionStorage(key: string): void {
  if (!isBrowser()) return;
  sessionStorage.removeItem(key);
}
